<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/meeting">Meeting</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Lista</li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <LoadedComponent :loading="loading" />
    <div class="container" v-if="!loading">
      <div class="alert alert-success mb-2" v-if="successMessage">
        <h5 style="color: white; text-align: center; font-family: sans-serif">
          {{ successMessage }}
        </h5>
      </div>

      <div class="alert alert-danger mb-2" v-if="errorMessage">
        <h5 style="color: white; text-align: center; font-family: sans-serif">
          {{ errorMessage }}
        </h5>
      </div>
      <div class="row">
        <div
          class="col-md-3 pt-0 pt-md-2 pl-0 pl-md-5 mb-0 mb-md-4 text-center"
        >
          <router-link
            to="meeting/create"
            class="btn btn-primary custom-primary"
            >Crea un nuovo meeting
          </router-link>
        </div>

        <div
          class="col-md-9 pt-0 pt-md-2 pl-0 pl-md-5 mb-0 mb-md-4 m-3 m-md-0 text-center"
        >
          <div class="widget widget-search">
            <form>
              <label for="ws" class="sr-only">Cerca fra i casi</label>
              <input
                type="search"
                class="form-control"
                name="q"
                id="ws"
                placeholder="Cerca fra i meeting"
                v-model="searchText"
                @input="performSearchMeeting"
              />
              <button type="button" class="btn">
                <i class="icon-search"></i><span class="sr-only">Cerca</span>
              </button>
            </form>
          </div>
          <!-- End .widget -->
        </div>
      </div>

      <div class="row reload-forum-page">
        <div class="col-md-12 align-items-center">
          <div class="row">
            <div class="col-3 col-md-3">
              <h6 class="font-weight-bold text-md-left text-center">Titolo</h6>
            </div>
            <div class="col-3 col-md-3">
              <h6 class="font-weight-bold text-md-left text-center">Autore</h6>
            </div>
            <div class="col-3 col-md-2">
              <h6 class="font-weight-bold text-md-left text-center">Inizio</h6>
            </div>
            <div class="col-3 col-md-2">
              <h6 class="font-weight-bold text-md-left text-center">Fine</h6>
            </div>
            <div
              class="col-md-2 d-flex align-items-center d-none d-md-block"
            ></div>
          </div>
          <hr />
          <div v-if="meetings.length > 0">
            <div
              class="row p-md-4 p-2"
              v-for="meeting in meetings"
              :key="meeting.id"
            >
              <div class="col-md-3 product-content">
                <p class="font-weight-bolder text-md-left text-center">
                  {{ meeting.name }}
                </p>
              </div>
              <div class="col-md-3">
                <p class="font-weight-bolder text-md-left text-center">
                  {{ meeting.author }}
                </p>
              </div>
              <div class="col-md-2">
                <p class="font-weight-bolder text-md-left text-center">
                  {{ meeting.datetime_start }}
                </p>
              </div>
              <div class="col-md-2 mb-2 mb-md-0">
                <p class="font-weight-bolder text-md-left text-center">
                  {{ meeting.datetime_end }}
                </p>
              </div>
              <div class="col-md-2 align-items-center text-md-left text-center">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  @click="checkMeeting(meeting.slug)"
                >
                  <!-- Può entrare -->
                  <i class="las la-lock-open" v-if="meeting.shows == 1"></i>
                  <!-- Non può entrare -->
                  <i class="las la-lock" v-if="meeting.shows == 0"></i>
                  Accedi
                </button>
                <hr class="d-block d-md-none" />
              </div>
            </div>
          </div>
          <div v-else>
            <p>Nessun Risultato</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import router from "@/router";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
export default {
  name: "MeetingPage",
  props: {},
  components: { LoadedComponent },
  data() {
    return {
      successMessage: "",
      errorMessage: "",
      meetings: [],
      allMeetings: [],
      errors: [],
      loading: true,
      searchText: "",
    };
  },
  mounted() {
    this.successMessage = localStorage.getItem("messageSuccessMeeting");
    this.errorMessage = localStorage.getItem("messageErrorMeeting");
    if (this.successMessage !== null) {
      const $toast = useToast();
      $toast.open({
        message: this.successMessage,
        type: "success",
        position: "top-right",
        // all of other options may go here
      });
    }
    if (this.errorMessage !== null) {
      const $toast = useToast();
      $toast.open({
        message: this.errorMessage,
        type: "info",
        position: "top-right",
        // all of other options may go here
      });
    }
    localStorage.removeItem("messageSuccessMeeting");
    localStorage.removeItem("messageErrorMeeting");
    httpauth
      .get("/meetings")
      .then((response) => {
        var data = response.data;
        this.meetings = data.data;
        this.allMeetings = data.data;
        this.loading = false;

        // Gestisci l'array di oggetti come desiderato
      })
      .catch((error) => {
        if (
          error.response.status == 401 &&
          error.response.data.message == "Unauthenticated."
        ) {
          const auth = useAuth();
          auth.clearToken();
          window.location.href = "/";
        }
      });
  },
  created() {},
  methods: {
    performSearchMeeting() {
      if (!this.searchText) {
        this.meetings = this.allMeetings;
        return;
      }
      var searchTerm = this.searchText.toLowerCase();
      this.meetings = this.allMeetings.filter((item) =>
        item.name.toLowerCase().includes(searchTerm)
      );
    },
    checkMeeting(slugMeeting) {
      httpauth
        .get("/meetings/check-meeting/" + slugMeeting)
        .then((response) => {
          if (response.data.status == 1) {
            if (
              response.data.data.status == "programming" ||
              response.data.data.status == "progress"
            ) {
              router.push("/meeting/show/" + slugMeeting);
              return;
            } else if (response.data.data.status == "publish") {
              router.push("/meeting/registration/" + slugMeeting);
              return;
            }

            return;
          }
          this.errorMessage = response.data.message;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          ) {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          if (error.response.status == 404 || error.response.status == 401) {
            this.errorMessage = error.response.message;
          }
        });
    },
  },
};
</script>